function _gtmSrc(window, document) {
  const TB_CHROME =
    'https://chrome.google.com/webstore/detail/toggl-track-productivity/oejgccbfbmkkpaidnkphaiaecficdnfn'
  const TB_FIREFOX =
    'https://addons.mozilla.org/en-US/firefox/addon/toggl-button-time-tracker'
  const APP_IOS = 'https://apps.apple.com/us/app/toggl/id1291898086'
  const APP_ANDROID =
    'https://play.google.com/store/apps/details?id=com.toggl.giskard'
  const APP_DESKTOP = [
    'https://toggl.com/track/toggl-desktop/downloads/TogglTrack-windows64.exe',
    'https://toggl.com/track/toggl-desktop/downloads/TogglTrack-windows.exe',
    'https://toggl.github.io/toggldesktop/download/macos-stable/',
    'https://support.toggl.com/en/articles/2410832-toggl-track-desktop-app-for-linux',
  ]
  window._gtmLinkHandler = (e) => {
    const anchor = e.target.closest('a')
    const href = anchor ? anchor.href : ''

    if (href.includes(TB_CHROME)) {
      window.dataLayer.push({
        event: 'browser_extension.clickthrough',
        type: 'chrome',
      })
    }

    if (href.includes(TB_FIREFOX)) {
      window.dataLayer.push({
        event: 'browser_extension.clickthrough',
        type: 'firefox',
      })
    }

    if (href.includes(APP_IOS)) {
      window.dataLayer.push({
        event: 'mobile_app.clickthrough',
        type: 'iOS',
      })
    }

    if (href.includes(APP_ANDROID)) {
      window.dataLayer.push({
        event: 'mobile_app.clickthrough',
        type: 'Android',
      })
    }

    if (APP_DESKTOP.some((url) => href.includes(url))) {
      window.dataLayer.push({
        event: 'desktop_app.clickthrough',
      })
    }
  }
  document.addEventListener('click', window._gtmLinkHandler)
}

export default `${_gtmSrc.toString()};_gtmSrc(window, document)`
